import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  CALENDAR_EVENT,
  CALENDAR_EVENT_ALL,
  CALENDAR_EVENT_CREATE,
  CALENDAR_EVENT_DELETE,
  CALENDAR_EVENT_LIST,
  CALENDAR_EVENT_LIST_STUDENT,
  CALENDAR_EVENT_TEACHING_WEEKS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const calendarEvent = createAsyncThunk(
  CALENDAR_EVENT,
  async (params: PayloadCreatorParams<`${typeof API.CALENDAR_EVENT}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.calendarEvent(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const calendarEventCreate = createAsyncThunk(
  CALENDAR_EVENT_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.CALENDAR_EVENT}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.calendarEventCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const calendarEventDelete = createAsyncThunk(
  CALENDAR_EVENT_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.CALENDAR_EVENT}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.calendarEventDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const calendarEventList = createAsyncThunk(
  CALENDAR_EVENT_LIST,
  async (params: PayloadCreatorParams<`${typeof API.CALENDAR_EVENT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.calendarEventList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const calendarEventAll = createAsyncThunk(
  CALENDAR_EVENT_ALL,
  async (params: PayloadCreatorParams<`${typeof API.CALENDAR_EVENT_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.calendarEventAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const calendarEventListStudent = createAsyncThunk(
  CALENDAR_EVENT_LIST_STUDENT,
  async (params: PayloadCreatorParams<`${typeof API.CALENDAR_EVENT_STUDENT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.calendarEventListStudent(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const calendarEventTeachingWeeks = createAsyncThunk(
  CALENDAR_EVENT_TEACHING_WEEKS,
  async (params: PayloadCreatorParams<`${typeof API.CALENDAR_EVENT_TEACHING_WEEKS}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.calendarEventTeachingWeeks(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const calendarEventClear = createAction(`${CALENDAR_EVENT}/clear`)

export const calendarEventListClear = createAction(`${CALENDAR_EVENT_LIST}/clear`)

export const calendarEventAllClear = createAction(`${CALENDAR_EVENT_ALL}/clear`)
